var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBoxAlt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5312 15.75C15.5312 16.0625 15.2813 16.3125 14.9688 16.3125H3.46875C3.15625 16.3125 2.90625 16.0625 2.90625 15.75V4.25C2.90625 3.9375 3.15625 3.6875 3.46875 3.6875H13.9062L15.1562 2.28125C15.0938 2.28125 15.0625 2.28125 15 2.28125H3.46875C2.40625 2.28125 1.5 3.15625 1.5 4.25V15.7812C1.5 16.875 2.375 17.75 3.46875 17.75H15C16.0625 17.75 16.9688 16.875 16.9688 15.7812V4.53125L15.5625 6.09375V15.75H15.5312Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0624 1.1569C17.7812 0.906902 17.3437 0.906902 17.0624 1.2194L15.9062 2.50065L14.8437 3.68815L8.87493 10.3757L5.90618 7.6569C5.62493 7.4069 5.18743 7.4069 4.90618 7.68815C4.65618 7.9694 4.65618 8.4069 4.93743 8.68815L8.43743 11.8757C8.56243 12.0007 8.74993 12.0632 8.90618 12.0632H8.93743C9.12493 12.0632 9.31243 11.9694 9.43743 11.8444L15.5312 5.0319L16.8124 3.5944L18.1249 2.12565C18.3749 1.8444 18.3749 1.4069 18.0624 1.1569Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxAlt);
export default __webpack_public_path__ + "static/media/checkBoxAlt.44f023ad98045a3222cad6417b9b5c60.svg";
export { ForwardRef as ReactComponent };